import type { User } from '@auth0/auth0-react';
import type { ToOptions } from '@tanstack/react-router';

import type { RmClaims } from 'src/api/queries/user';

export class AccessDeniedError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'AccessDeniedError';
  }
}

export class SAMLEmailNotFoundError extends Error {
  constructor(originalProvider?: string) {
    super(originalProvider);
    this.name = 'SAMLEmailNotFoundError';
  }
}

export class LoginValidatorError extends Error {
  constructor(originalProvider?: string) {
    super(originalProvider);
    this.name = 'LoginValidatorError';
  }
}

export class MultipleCandidatesError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'MultipleCandidatesError';
  }
}

export class OrganizationNotFoundError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'OrganizationNotFoundError';
  }
}

export class DomainNotForwardedError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'DomainNotForwardedError';
  }
}

export class DomainNotVerifiedInOrgError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'DomainNotVerifiedInOrgError';
  }
}

export class SocialLoginConflictError extends Error {
  constructor(originalProvider?: string) {
    super(originalProvider);
    this.name = 'SocialLoginConflictError';
  }
}

export class SSOLoginRequiredError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'SSOLoginRequiredError';
  }
}

export class SocialAccountNotFoundError extends Error {
  constructor(provider?: string) {
    super(provider);
    this.name = 'SocialAccountNotFoundError';
  }
}

export class AccountLinkingMismatchError extends Error {
  constructor(
    public redirect: ToOptions['to'] | (string & {}), // Gives autocompletion, but still allows any string
    public currentUser: User | RmClaims,
    public expectedUser: User | RmClaims
  ) {
    super(
      '[AccountLinkingMismatchError]: User id did not match linkable account id'
    );
    this.name = 'AccountLinkingMismatchError';
  }
}

export class EmailNotVerifiedError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'EmailNotVerifiedError';
  }
}
